import * as React from "react";
import { Icon28ArrowLeftOutline } from '@vkontakte/icons/dist/28/arrow_left_outline_28';
import { Icon28ArrowRightOutline } from '@vkontakte/icons/dist/28/arrow_right_outline_28';


import './Question.css';
import { Button, Div, FixedLayout, Headline } from "@vkontakte/vkui";

class Question extends React.Component {
  render() {
    if ((this.props.question === null) || (this.props.questions.length === 0)) {
      return null;
    }

    let question = this.props.questions[this.props.question];
    return <FixedLayout vertical="top" filled className="question">
      <Div className="header-container">
        <Button mode="tertiary" before={<Icon28ArrowLeftOutline/>} size="l" onClick={this.props.onPrevious} />
        {question.name && <Headline weight="1">{question.name}</Headline>}
        {question.flag && <img src={question.flag} alt=""/>}
        {question.capital && <Headline weight="1">{question.capital}</Headline>}
        <Button mode="tertiary" before={<Icon28ArrowRightOutline/>} size="l" onClick={this.props.onNext} />
      </Div>
    </FixedLayout>;
  }
}

export default Question;
